import { render, staticRenderFns } from "./relationdevice.vue?vue&type=template&id=5c6ea05d"
import script from "./relationdevice.vue?vue&type=script&lang=js"
export * from "./relationdevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports